import React from 'react';
import ReactDOM from 'react-dom';
import { CheckPDFPreview } from 'ui-toolkit/components/PDFPreview/CheckPDFPreview';
import { CheckForAvailableFundsModal } from '../../../../escrow/escrowCreateEdit/checkForAvailableFundsModal/CheckForAvailableFundsModal';

interface CheckModalsProps {
  showPrintModal: boolean;
  printedCheckData: Uint8Array | null;
  targetElement: HTMLElement | null;
  setShowPrintModal: (show: boolean) => void;
  onPrintAndSend: () => void;
  showNotEnoughWarning: boolean;
  onIgnoreWarning: () => void;
  setShowNotEnoughWarning: (show: boolean) => void;
  onPrint: () => void;
}

export const CheckModals: React.FC<CheckModalsProps> = ({
  showPrintModal,
  printedCheckData,
  targetElement,
  setShowPrintModal,
  onPrintAndSend,
  showNotEnoughWarning,
  onIgnoreWarning,
  setShowNotEnoughWarning,
  onPrint,
}) => {
  return (
    <>
      {showPrintModal &&
        printedCheckData &&
        targetElement &&
        ReactDOM.createPortal(
          <CheckPDFPreview
            file={printedCheckData}
            onClose={() => {
              setShowPrintModal(false);
            }}
            onPrint={onPrint}
            onSend={onPrintAndSend}
          />,
          targetElement
        )}
      {showNotEnoughWarning &&
        targetElement &&
        ReactDOM.createPortal(
          <CheckForAvailableFundsModal
            submitData={onIgnoreWarning}
            type={'check'}
            handleClose={() => setShowNotEnoughWarning(false)}
          />,
          targetElement
        )}
      {showNotEnoughWarning && !targetElement && (
        <CheckForAvailableFundsModal
          submitData={onIgnoreWarning}
          type={'check'}
          handleClose={() => setShowNotEnoughWarning(false)}
        />
      )}
    </>
  );
};
